import React from 'react'

import './CalculatorLegend.css'

function CalculatorLegend(props) {


    // const handleClose = () =>
    // {
    //     props.handleClose();
    // }


  return (
    <div className='calculator-legend'>
            <div className='calculator-legend-header'>
                Premium Projection Help
            </div>
            <div className='calculator-legend-vars'>
                <div className='calculator-legend-var'>
                    Avg Conversion Rate = {props.conversionRate*100}%
                </div>
                <div className='calculator-legend-var'>
                    Avg Case Size = ${props.averageCaseSize.toLocaleString('en', {useGrouping:true})}
                </div>
                <div className='calculator-legend-var'>
                    Year Remaining = {Math.round(props.ratioOfYear*100)}%
                </div>
                <div className='calculator-legend-var'>
                    Avg Contacts per Open = {Math.round(props.contactsPerOpen*10)/10}
                </div>
                <div className='calculator-legend-var'>
                    Avg Introductions per Open = {Math.round(props.introsPerOpen*10)/10}
                </div>
            
            
            </div>
            <div className='calculator-legend-content' style = {{display: 'flex'}}>

                <div className='calculator-legend-column' style = {{borderRight: '1px solid var(--primary-color)'}}>
                    <div className='calculator-legend-column-header'>
                        Premium Projected YTD
                    </div>
                    <div className='calculator-legend-column-text'>
                        Income = Real Opens x Avg Conversion Rate x Avg Case Size
                    </div>
                
                </div>
                <div className='calculator-legend-column' >
                    <div className='calculator-legend-column-header'>
                        Calendar Year Premium Projection
                    </div>
                    <div className='calculator-legend-column-text'>
                        Income = Projected Opens x Avg Conversion Rate x Avg Case Size
                    </div>
                    <div className='calculator-legend-column-text'>
                        Calendar Year Projected = Projected YTD / Year Remaining
                    </div>
                </div>
                <div className='calculator-legend-column' style = {{borderLeft: '1px solid var(--primary-color)'}}>
                    <div className='calculator-legend-column-header'>
                        Premium Goal
                    </div>
                    <div className='calculator-legend-column-text'>
                        Opens Goal = Income Goal / Avg Case Size / Avg Conversion Rate
                    </div>
                    <div className='calculator-legend-column-text'>
                        Contacts = Opens Goal x Avg Contacts per Open
                    </div>
                    <div className='calculator-legend-column-text'>
                        Introductions = Opens Goal x Avg Introductions per Open
                    </div>
                </div>
            </div>
</div>  
)}



export default CalculatorLegend